import angular from 'angular';
import $ from 'jquery';
import tftSpinnerTemplate from '../components/common/tft-spinner/template.html';
import logger from '../shared/logger';

export function PrintService(DocumentService, $timeout) {
    const print = (htmlElement, options) => {
        const preparedHtml = prepareForPrint(htmlElement, options);
        const popupWin = window.open('', '_blank', `width=817,height=${$(window).height()}`);

        popupWin.document.write(preparedHtml);
        popupWin.document.close();
    };

    const printAsync = (asyncJob, options) => {
        const popupWin = window.open('', '_blank', `width=817,height=${$(window).height()}`);
        popupWin.document.write(getWaitingPage());
        popupWin.document.close();

        return asyncJob.then(html => $timeout(() => {
            popupWin.document;
            popupWin.document.write(prepareForPrint(html, options));
            popupWin.document.close();
        })).catch(err => logger.error(err));
    };

    const getWaitingPage = () => {
        const hostLocation = DocumentService.getCurrentLocation();
        const head = DocumentService.getHeadContent(hostLocation);

        return `
            <html>
                ${head}
                <body>${tftSpinnerTemplate}</body>
            </html>
        `;
    };

    const prepareForPrint = (htmlElement, options) =>
        DocumentService.getProcessedHtml(htmlElement, {
            script: '<script>window.addEventListener("load", () => window.print());</script>',
            ...options,
        });

    return {
        print,
        printAsync,
    };
}

angular.module('TALENYA-FE').factory('PrintService', PrintService);
